import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminHome() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const tienda_data = localStorage.getItem("tienda_data");

    if (!tienda_data) {
      navigate("/administracion/tienda/login", { replace: true });
      return;
    }

    try {
      setUser(JSON.parse(tienda_data));
    } catch {
      navigate("/administracion/tienda/login", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="page-container">
      <style>{styles}</style>

      <div className="home-card">
        <h1 className="home-title">
          Bienvenido de nuevo,
          <span className="home-user">
            {" "}
            {user?.nombre} {user?.apellido}
          </span>
        </h1>

        <p className="home-subtitle">Panel de administración</p>

        <div className="home-divider" />

        <p className="home-text">
          Usa la barra lateral para administrar productos, pedidos, clientes y la configuración de tu tienda.
        </p>
      </div>
    </div>
  );
}

export default AdminHome;

const styles = `
.page-container {
  padding: 40px 0;
  font-family: 'Segoe UI';
}

.home-card {
  max-width: 720px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  padding: 48px;
}

.home-title {
  font-size: 28px;
  font-weight: 700;
  color: #2F4779;
  margin-bottom: 8px;
}

.home-user {
  color: #0284C7;
}

.home-subtitle {
  font-size: 14px;
  color: #64748B;
  margin-bottom: 28px;
}

.home-divider {
  height: 1px;
  background: #E2E8F0;
  margin-bottom: 24px;
}

.home-text {
  font-size: 15px;
  line-height: 1.6;
  color: #475569;
}
`;